var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "d-flex" }, [
          _vm.data.suppliers !== undefined && _vm.data.suppliers.length === 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-start mb-05" },
                  [
                    _c("div", { staticClass: "p-05" }, [
                      _c("img", {
                        staticClass: "round",
                        attrs: {
                          src:
                            _vm.data.module.owner.avatar !== null
                              ? _vm.data.module.owner.avatar.url
                              : "/images/avatar.png",
                          alt: "avatar",
                          height: "30",
                          width: "30",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "p-0  pt-05 justify-content-start" },
                      [
                        _c("div", { staticClass: "user-name text-bold-600" }, [
                          _c(
                            "div",
                            { staticClass: "dropdown dropdown-user nav-item" },
                            [
                              _c("a", {
                                staticClass:
                                  "dropdown-toggle dropdown-user-link",
                                attrs: { href: "#", "data-toggle": "dropdown" },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.data.module.owner.first_name +
                                      " " +
                                      _vm.data.module.owner.last_name
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _vm._l(
                                _vm.data.module.owner.badges,
                                function (badge) {
                                  return _c("span", [
                                    _c("img", {
                                      staticStyle: {
                                        "margin-top": "-3px",
                                        height: "15px",
                                      },
                                      attrs: {
                                        src: badge.image,
                                        "data-toggle": "tooltip",
                                        "data-placement": "bottom",
                                        title: badge.name,
                                      },
                                    }),
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              _vm.data.module.owner.user_badge_id !== null
                                ? _c("span", [
                                    _c("img", {
                                      staticStyle: {
                                        "margin-top": "-3px",
                                        height: "15px",
                                      },
                                      attrs: {
                                        src: _vm.data.module.owner
                                          .user_badge_image.url,
                                        "data-toggle": "tooltip",
                                        "data-placement": "bottom",
                                        title:
                                          _vm.data.module.owner.user_badge_name,
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-center",
                                },
                                [_c("profile", { attrs: { data: _vm.data } })],
                                1
                              ),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "-3px",
                              "line-height": "1",
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "font-small-2 text-light",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.data.module.owner.position
                                ),
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "font-small-2 text-light" },
                              [_vm._v(" at ")]
                            ),
                            _c("span", {
                              staticClass: "font-small-2 text-light",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.data.module.owner.organisation
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-group mt-05",
                        staticStyle: { right: "0.5rem", position: "absolute" },
                      },
                      [
                        _c("span", {
                          staticClass: "font-small-1 text-light ",
                          staticStyle: { "margin-top": "4px" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.ago(_vm.data.module.created_at)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown" }, [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-menu",
                              attrs: {
                                "aria-labelledby": "dropdownMenuButton200",
                              },
                            },
                            [
                              _vm.canUpdate || _vm.isAdmin === true
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          href:
                                            "/member/zoom/" +
                                            _vm.data.module.zoom_id +
                                            "/edit",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "feather icon-settings",
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.__("globals.edit_post")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: { href: "#" },
                                        on: { click: _vm.destroy },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "feather icon-trash-2",
                                        }),
                                        _vm._v(
                                          _vm._s(
                                            _vm.__("globals.delete_post")
                                          ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item danger",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.report.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-alert-triangle",
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.__("globals.report_post")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm.data.suppliers !== undefined &&
              _vm.data.suppliers.length === 1
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-start mb-05" },
                  [
                    _c("div", { staticClass: "p-05" }, [
                      _c("img", {
                        staticClass: "round",
                        attrs: {
                          src:
                            _vm.data.suppliers[0].supplier_avatar !== null
                              ? _vm.data.suppliers[0].supplier_avatar.url
                              : "/images/avatar.png",
                          alt: "avatar",
                          height: "30",
                          width: "30",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "p-0  pt-05 justify-content-start" },
                      [
                        _c(
                          "div",
                          { staticClass: "user-name text-bold-600 text-dark" },
                          [
                            _c("a", {
                              staticClass: "text-dark",
                              attrs: { href: "#" },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.data.suppliers[0].title
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "font-small-2 text-primary",
                            staticStyle: { "margin-top": "-5px" },
                          },
                          [
                            _vm._v(
                              "@" +
                                _vm._s(_vm.data.suppliers[0].slug) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c(
            "div",
            {
              staticClass: "card-img-top img-fluid",
              attrs: { id: "gallery-" + _vm.data.id },
            },
            [
              _c("img", {
                staticClass: " img-fluid",
                attrs: {
                  src:
                    _vm.data.module.cover === null
                      ? "/images/cover.jpg"
                      : _vm.data.module.cover.url,
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body p-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex mt-0 ml-1 mr-1 mb-0 pt-1 border-top align-items-center justify-content-start",
              },
              [
                _c("span", { staticClass: "h3" }, [
                  _c("a", {
                    staticStyle: { color: "inherit" },
                    attrs: { href: "/member/zoom/" + _vm.data.module.zoom_id },
                    domProps: { textContent: _vm._s(_vm.data.module.title) },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-auto" }, [
                  _c(
                    "div",
                    {
                      staticClass: "badge badge-pill bg-gradient-secondary",
                      staticStyle: { padding: "0.2rem 0.5rem" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-video" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("meeting.title_singular")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex ml-1 mr-1 mt-0" }, [
              _vm._m(1),
              _c("span", {
                staticClass: "h6 primary",
                domProps: { textContent: _vm._s(_vm.showDateTime) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: " pt-1 pl-1 pr-1 border-top" }, [
              _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll mb-0",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.data.module.description.substring(0, 550)
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "font-small-3",
                    attrs: { href: "/member/zoom/" + _vm.data.module.zoom_id },
                  },
                  [
                    _vm._v(_vm._s(_vm.__("globals.read_more")) + " "),
                    _c("i", { staticClass: "feather icon-chevron-right" }),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.module.event_price > 0
              ? _c("div", { staticClass: "d-flex border-top" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex ml-05 mr-05  mb-0 pb-05 pt-05 border-top align-items-center justify-content-start",
                    },
                    [
                      _c("span", { staticClass: "font-small-2 ml-05" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(
                                _vm.data.module.event_price,
                                _vm.site_tax
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-auto p-1" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-sm btn-primary waves-effect waves-light",
                        attrs: {
                          href:
                            "/member/zoom/" +
                            _vm.data.module.zoom_id +
                            "/add_to_cart",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-dollar" }),
                        _vm._v(
                          _vm._s(_vm.__("globals.buy_now")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.module.event_price === 0
              ? _c("div", { staticClass: "d-flex border-top" }, [
                  _c("div", { staticClass: "ml-auto p-1" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-sm btn-primary waves-effect waves-light",
                        attrs: {
                          href:
                            "/member/zoom/" +
                            _vm.data.module.zoom_id +
                            "/register",
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.__("meeting.form.buttons.register_now")
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.data.groups !== undefined && _vm.data.groups.length > 0
              ? _c("div", { staticClass: "ml-05 mr-05" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "/member/group/" + _vm.data.groups[0].slug,
                      },
                    },
                    [
                      _c("div", { staticClass: "card text-white" }, [
                        _c("img", {
                          staticClass: "card-img img-fluid",
                          staticStyle: { height: "3rem" },
                          attrs: {
                            src:
                              _vm.data.groups[0].group_cover == null
                                ? "/images/cover.jpg"
                                : _vm.data.groups[0].group_cover.url,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "text-white mb-0",
                                staticStyle: { "line-height": "1rem" },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.posted_in")) + " "
                                  ),
                                ]),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.data.groups[0].title)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-sm btn-outline-white ml-auto",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.__("globals.view_group")) + " "
                                ),
                                _c("i", {
                                  staticClass: "feather icon-chevron-right",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm.data.suppliers !== undefined &&
                _vm.data.suppliers.length > 0
              ? _c("div", { staticClass: "ml-05 mr-05" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/member/" +
                          _vm.data.suppliers[0].type +
                          "/" +
                          _vm.data.suppliers[0].slug,
                      },
                    },
                    [
                      _c("div", { staticClass: "card text-white" }, [
                        _c("img", {
                          staticClass: "card-img img-fluid",
                          staticStyle: { height: "3rem" },
                          attrs: {
                            src:
                              _vm.data.suppliers[0].supplier_cover_image == null
                                ? "/images/cover.jpg"
                                : _vm.data.suppliers[0].supplier_cover_image
                                    .url,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "text-white mb-0",
                                staticStyle: { "line-height": "1rem" },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.posted_to")) + " "
                                  ),
                                ]),
                                _vm._v(
                                  " " + _vm._s(_vm.data.suppliers[0].title)
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-sm btn-outline-white ml-auto",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.__("globals.view_page")) + " "
                                ),
                                _c("i", {
                                  staticClass: "feather icon-chevron-right",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between border-top ml-05 mr-05",
              },
              [
                _c(
                  "div",
                  { staticClass: "p-05" },
                  [
                    _c("like", {
                      attrs: { post: _vm.data.module, type: "zoom" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-05", staticStyle: { "margin-top": "1px" } },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "font-small-3 text-bold-700",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showComments(_vm.data.id)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-comment-o" }),
                        _vm._v(" " + _vm._s(_vm.__("globals.comment")) + " "),
                        _c("span", {
                          domProps: { textContent: _vm._s(_vm.commentsCount) },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("social-share", {
                  attrs: {
                    id: _vm.data.id,
                    social: this.data.module.socialShare,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("comments", {
        attrs: {
          data: _vm.data.module.comments,
          newsfeed_id: _vm.data.id,
          module: "zoom",
          slug: _vm.data.module.zoom_id,
          members: _vm.members,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "shareModal" + _vm.data.id,
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "exampleModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "exampleModalLabel" },
                    },
                    [_vm._v(_vm._s(_vm.__("meeting.share_meeting")))]
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "p-1 card border-light" }, [
                    _c("div", {}, [
                      _c(
                        "label",
                        { attrs: { for: "comment_body" + _vm.data.id } },
                        [_vm._v(_vm._s(_vm.__("globals.enter_comment")))]
                      ),
                      _vm._v(" "),
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: {
                          name: "comment_body" + _vm.data.id,
                          id: "comment_body" + _vm.data.id,
                          cols: "30",
                          rows: "3",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-1" }, [
                      _c("label", { attrs: { for: "feed" + _vm.data.id } }, [
                        _vm._v(_vm._s(_vm.__("globals.select_share"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          staticClass: "form-control",
                          attrs: {
                            name: "feed" + _vm.data.id,
                            id: "feed" + _vm.data.id,
                          },
                        },
                        [
                          _c("option", { attrs: { value: "profile" } }, [
                            _vm._v(_vm._s(_vm.__("globals.your_newsfeed"))),
                          ]),
                          _vm._v(" "),
                          _vm.groups_follow !== undefined
                            ? _c(
                                "optgroup",
                                {
                                  attrs: {
                                    label: _vm.__("globals.share_group"),
                                  },
                                },
                                _vm._l(_vm.groups_follow, function (group) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: { value: "group_" + group.id },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(group.title) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.suppliers_follow !== undefined
                            ? _c(
                                "optgroup",
                                {
                                  attrs: {
                                    label: _vm.__("globals.share_supplier"),
                                  },
                                },
                                _vm._l(
                                  _vm.suppliers_follow,
                                  function (supplier) {
                                    return _c(
                                      "option",
                                      {
                                        domProps: {
                                          value: "supplier_" + supplier.id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(supplier.title) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "d-flex" }, [
                        _vm.data.suppliers !== undefined &&
                        _vm.data.suppliers.length === 0
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start mb-05",
                                },
                                [
                                  _c("div", { staticClass: "p-05" }, [
                                    _c("img", {
                                      staticClass: "round",
                                      attrs: {
                                        src:
                                          _vm.data.module.owner.avatar !== null
                                            ? _vm.data.module.owner.avatar.url
                                            : "/images/avatar.png",
                                        alt: "avatar",
                                        height: "30",
                                        width: "30",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "p-0  pt-05 justify-content-start",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-name text-bold-600",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropdown dropdown-user nav-item",
                                            },
                                            [
                                              _c("a", {
                                                staticClass:
                                                  "dropdown-toggle dropdown-user-link",
                                                attrs: {
                                                  href: "#",
                                                  "data-toggle": "dropdown",
                                                },
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.data.module.owner
                                                      .first_name +
                                                      " " +
                                                      _vm.data.module.owner
                                                        .last_name
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.data.module.owner.badges,
                                                function (badge) {
                                                  return _c("span", [
                                                    _c("img", {
                                                      staticStyle: {
                                                        "margin-top": "-3px",
                                                        height: "15px",
                                                      },
                                                      attrs: {
                                                        src: badge.image,
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement":
                                                          "bottom",
                                                        title: badge.name,
                                                      },
                                                    }),
                                                  ])
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.data.module.owner
                                                .user_badge_id !== null
                                                ? _c("span", [
                                                    _c("img", {
                                                      staticStyle: {
                                                        "margin-top": "-3px",
                                                        height: "15px",
                                                      },
                                                      attrs: {
                                                        src: _vm.data.module
                                                          .owner
                                                          .user_badge_image.url,
                                                        "data-toggle":
                                                          "tooltip",
                                                        "data-placement":
                                                          "bottom",
                                                        title:
                                                          _vm.data.module.owner
                                                            .user_badge_name,
                                                      },
                                                    }),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu dropdown-menu-center",
                                                },
                                                [
                                                  _c("profile", {
                                                    attrs: { data: _vm.data },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "-3px",
                                            "line-height": "1",
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "font-small-2 text-light",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.data.module.owner.position
                                              ),
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "font-small-2 text-light",
                                            },
                                            [_vm._v(" at ")]
                                          ),
                                          _c("span", {
                                            staticClass:
                                              "font-small-2 text-light",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.data.module.owner
                                                  .organisation
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-group mt-05",
                                      staticStyle: {
                                        right: "0.5rem",
                                        position: "absolute",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "font-small-1 text-light ",
                                        staticStyle: { "margin-top": "4px" },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.ago(_vm.data.module.created_at)
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "dropdown" }, [
                                        _vm._m(3),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-menu",
                                            attrs: {
                                              "aria-labelledby":
                                                "dropdownMenuButton200",
                                            },
                                          },
                                          [
                                            _vm.canUpdate ||
                                            _vm.isAdmin === true
                                              ? _c("div", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: {
                                                        href:
                                                          "/member/zoom/" +
                                                          _vm.data.module
                                                            .zoom_id +
                                                          "/edit",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "feather icon-settings",
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.__(
                                                            "globals.edit_post"
                                                          )
                                                        ) +
                                                          "\n                                                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item",
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: _vm.destroy,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "feather icon-trash-2",
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.__(
                                                            "globals.delete_post"
                                                          )
                                                        ) +
                                                          "\n                                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "dropdown-item danger",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.report.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-alert-triangle",
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.__(
                                                      "globals.report_post"
                                                    )
                                                  ) +
                                                    "\n                                                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm.data.suppliers !== undefined &&
                            _vm.data.suppliers.length === 1
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start mb-05",
                                },
                                [
                                  _c("div", { staticClass: "p-05" }, [
                                    _c("img", {
                                      staticClass: "round",
                                      attrs: {
                                        src:
                                          _vm.data.suppliers[0]
                                            .supplier_avatar !== null
                                            ? _vm.data.suppliers[0]
                                                .supplier_avatar.url
                                            : "/images/avatar.png",
                                        alt: "avatar",
                                        height: "30",
                                        width: "30",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "p-0  pt-05 justify-content-start",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-name text-bold-600 text-dark",
                                        },
                                        [
                                          _c("a", {
                                            staticClass: "text-dark",
                                            attrs: { href: "#" },
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.data.suppliers[0].title
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-small-2 text-primary",
                                          staticStyle: { "margin-top": "-5px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                @" +
                                              _vm._s(
                                                _vm.data.suppliers[0].slug
                                              ) +
                                              "\n                                            "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "card-img-top img-fluid",
                            attrs: { id: "gallery-" + _vm.data.id },
                          },
                          [
                            _c("img", {
                              staticClass: " img-fluid",
                              attrs: {
                                src:
                                  _vm.data.module.cover === null
                                    ? "/images/cover.jpg"
                                    : _vm.data.module.cover.url,
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body p-0" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex mt-0 ml-1 mr-1 mb-0 pt-1 border-top align-items-center justify-content-start",
                            },
                            [
                              _c("span", { staticClass: "h3" }, [
                                _c("a", {
                                  staticStyle: { color: "inherit" },
                                  attrs: {
                                    href:
                                      "/member/zoom/" + _vm.data.module.zoom_id,
                                  },
                                  domProps: {
                                    textContent: _vm._s(_vm.data.module.title),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-auto" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "badge badge-pill bg-gradient-secondary",
                                    staticStyle: { padding: "0.2rem 0.5rem" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "feather icon-video",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.__("meeting.title_singular")
                                        ) +
                                        "\n                                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex ml-1 mr-1 mt-0" }, [
                            _vm._m(4),
                            _c("span", {
                              staticClass: "h6 primary",
                              domProps: {
                                textContent: _vm._s(_vm.showDateTime),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: " pt-1 pl-1 pr-1 border-top" },
                            [
                              _c("div", {
                                directives: [
                                  { name: "linkified", rawName: "v-linkified" },
                                ],
                                staticClass: "breakAll mb-0",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.module.description.substring(
                                      0,
                                      550
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "font-small-3",
                                    attrs: {
                                      href:
                                        "/member/zoom/" +
                                        _vm.data.module.zoom_id,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.read_more")) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "feather icon-chevron-right",
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.data.groups !== undefined &&
                          _vm.data.groups.length > 0
                            ? _c("div", { staticClass: "ml-05 mr-05" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "/member/group/" +
                                        _vm.data.groups[0].slug,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card text-white" },
                                      [
                                        _c("img", {
                                          staticClass: "card-img img-fluid",
                                          staticStyle: { height: "3rem" },
                                          attrs: {
                                            src:
                                              _vm.data.groups[0].group_cover ==
                                              null
                                                ? "/images/cover.jpg"
                                                : _vm.data.groups[0].group_cover
                                                    .url,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-white mb-0",
                                                staticStyle: {
                                                  "line-height": "1rem",
                                                },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.__(
                                                        "globals.posted_in"
                                                      )
                                                    ) + " "
                                                  ),
                                                ]),
                                                _vm._v(
                                                  "\n                                                        " +
                                                    _vm._s(
                                                      _vm.data.groups[0].title
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-sm btn-outline-white ml-auto",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.__("globals.view_group")
                                                  ) + " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-chevron-right",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm.data.suppliers !== undefined &&
                              _vm.data.suppliers.length > 0
                            ? _c("div", { staticClass: "ml-05 mr-05" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "/member/" +
                                        _vm.data.suppliers[0].type +
                                        "/" +
                                        _vm.data.suppliers[0].slug,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card text-white" },
                                      [
                                        _c("img", {
                                          staticClass: "card-img img-fluid",
                                          staticStyle: { height: "3rem" },
                                          attrs: {
                                            src:
                                              _vm.data.suppliers[0]
                                                .supplier_cover_image == null
                                                ? "/images/cover.jpg"
                                                : _vm.data.suppliers[0]
                                                    .supplier_cover_image.url,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "text-white mb-0",
                                                staticStyle: {
                                                  "line-height": "1rem",
                                                },
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.__(
                                                        "globals.posted_to"
                                                      )
                                                    ) + " "
                                                  ),
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.data.suppliers[0]
                                                        .title
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-sm btn-outline-white ml-auto",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.__("globals.view_page")
                                                  ) + " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-chevron-right",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(_vm._s(_vm.__("globals.close")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.sharePost(_vm.data.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.__("globals.share")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "primary mr-05" }, [
      _c("i", { staticClass: "feather icon-calendar" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "primary mr-05" }, [
      _c("i", { staticClass: "feather icon-calendar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }